import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { IntegradorService } from '../../../../services/integrador.service';
import { ToastService } from '../../../../services/toast.service';
import { Consumivel } from '../../../../types/Consumivel.type';
import { Instancia } from '../../../../types/Instancia.type';
import { BaixaconsumiveisService } from '../../../../services/baixaconsumiveis.service';

@Component({
  selector: 'app-baixaconsumiveis',
  templateUrl: './baixaconsumiveis.component.html',
  styleUrl: './baixaconsumiveis.component.css',
    providers: [DatePipe]
})
export class BaixaconsumiveisComponent implements OnInit {

  consumiveis!: Consumivel[];
  consumiveisSelecionados: Consumivel[] = []
  loading: boolean = false;
  rangeDates!: string;

  instanciaSelecionada!: string

  tentativasHabilitado: boolean = false;

  status: any[] = [ {name: 'Pendente', value: 'NAO_INTEGRADO' }
    , {name: 'Integrado', value: 'INTEGRADO'}
    , {name: 'Cancelado', value: 'CANCELADO'}
    , {name: 'Estornar', value: 'ESTORNAR'}
    , {name: 'Estornado', value: 'ESTORNADO'}
  ]

  constructor(private baixaConsumivel: BaixaconsumiveisService, private toastService: ToastService, private datePipe: DatePipe){}

  ngOnInit(){
    this.getConsumiveis();
    this.verificarTentativasHabilitado();
  }

  verificarTentativasHabilitado(){
    this.baixaConsumivel.getTentativasHabilitado().subscribe({
      next: () => {
        this.tentativasHabilitado = true;
        this.status.push({name: 'Tentativas Excedida', value: 'TENTA_EXCEDIDA'});
      },
      error: (error) => {
        if (error.status === 409) {
          this.tentativasHabilitado = false;
        }
      }
    });
  }

  getConsumiveis(){

    if (
      this.instanciaSelecionada != undefined &&
      this.rangeDates != undefined
    ) {
      let dataInicial = this.getDataPipeTransForm(this.rangeDates[0]);
      let dataFinal = this.getDataPipeTransForm(this.rangeDates[1]);

    this.loading = true
    this.baixaConsumivel.getConsumiveis(this.instanciaSelecionada, dataInicial, dataFinal).subscribe({
      next: (data) => {
        this.consumiveis = data;
      },
      error: (error) => {
        this.toastService.erro(error.error.title, "Erro ao buscar: " + error.error.detail)
      },
      complete: () => {
        this.loading = false;
      }
    })
  }
}

getDataPipeTransForm(data: string): string | null {
  return this.datePipe.transform( data,'yyyy-MM-dd');
}

exportar(){
  if (
    this.instanciaSelecionada == undefined
  ) {
    this.toastService.alerta('Instância', 'Selecione uma instância');

    return;
  }

  if (this.rangeDates == undefined) {
    this.toastService.alerta('Período', 'Selecione o período');

    return;
  }

  

  if(this.consumiveisSelecionados.length > 0){
    this.loading = true;
    
    let ids = this.consumiveisSelecionados.map(m => m.idConsum)

    let corpo = {
      ids: ids,
      usuario: localStorage.getItem("cdUsuarioErp")
    }

  this.baixaConsumivel
    .exportarConsumiveis(
      ids
    )
    .subscribe({next: (value) => {
      const url = window.URL.createObjectURL(value);
      const a = document.createElement('a')
      a.href = url
      a.download = 'data.xlsx'
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    error: (error) => {
      this.toastService.erro("Exportar", 'Erro ao exportar:' + error.error);
    },
    complete: () => {
      this.loading = false;
    },
      
    });

    
  }else{
    this.toastService.info("Exportar", 'Necessário selecionar os registros que devem ser exportados');
  }
}

reenviar(){
  if (this.consumiveisSelecionados.length === 0) {
    this.toastService.info('Reenviar', 'Necessário selecionar os registros que devem ser reenviados');

    return;
  }

  const possuiStatusInvalido = this.consumiveisSelecionados.some(c => c.fgStatusInteg !== 'TENTA_EXCEDIDA');

  if (possuiStatusInvalido) {
    this.toastService.alerta('Reenviar', 'Selecione apenas registros com status "Tentativas Excedida"');

    return;
  }

  const ids = this.consumiveisSelecionados.map(c => c.idConsum);

  this.loading = true;

  this.baixaConsumivel.reenviarConsumiveis(ids).subscribe({
    next: () => {
      this.toastService.sucesso('Reenviar', 'Registros reenviados com sucesso');
      this.consumiveisSelecionados = [];
      this.getConsumiveis();
    },
    error: (error) => {
      if (error.status === 409) {
        this.toastService.erro('Reenviar', 'Existe(m) registro(s) selecionado(s) que não está(ão) com status "Tentativas Excedida"');
      } else {
        this.toastService.erro('Reenviar', 'Erro ao reenviar os registros');
      }
    },
    complete: () => {
      this.loading = false;
    }
  });
}
}
